export const RT_ITEMS_PER_PAGE = 50;
